import { Injectable } from '@angular/core';
import { GolfEvent } from '../models/GolfEvent';
import { LeagueWeek } from '../models/LeagueWeek';
import { LeagueRound } from '../models/LeagueRound';
import { firstValueFrom } from 'rxjs';
import { CreateGolfEventRequest } from '../models/creategolfeventrequest';
import { HttpClient } from '@angular/common/http';
import { CreateLeagueWeekRequest } from '../models/createleagueweekrequest';
import { ConfigurationService } from './configuration.service';
import { GolfEventField } from '../models/golfeventfield';
import { PostScoreRequest } from '../models/postScoreRequest';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class GolfEventService {

  constructor(private http:HttpClient, private configService:ConfigurationService, private authenticationService:AuthenticationService) { 
    this.baseUrl = this.configService.getApiEndpoint();
  }

  baseUrl:string;

  async createEvent(request:CreateGolfEventRequest):Promise<number> {
    let endpoint = `${this.baseUrl}/golfevent`;
    let result = await firstValueFrom(this.http.post<number>(endpoint, request));
    return result;
  }

  async createLeagueWeek(request:CreateLeagueWeekRequest):Promise<number> {
    let endpoint = `${this.baseUrl}/leagueweek`;
    let result = await firstValueFrom(this.http.post<number>(endpoint, request));
    return result;
  }

  async searchEvents():Promise<Array<GolfEvent>> {
    let endpoint = `${this.baseUrl}/golfevents`;
    let result = await firstValueFrom(this.http.post<GolfEvent[]>(endpoint, {}));
    return result;
  }

  async getLeagueWeeks(eventId:number):Promise<Array<LeagueWeek>> {
    let endpoint = `${this.baseUrl}/leagueweeks`;
    let weeks = await firstValueFrom(this.http.post<LeagueWeek[]>(endpoint, { golfEventId: eventId }));
    return weeks;
  }

  async getGolfEventById(eventId:number):Promise<GolfEvent> {
    let events = await this.searchEvents();
    let eventsFound = events.filter(evt => evt.id.toString() === eventId.toString()); //I HATE the toString() here but there is a bug I can't get resolved.
    return eventsFound[0];
  }

  async searchField(eventId:number, hasPaid:boolean|null):Promise<Array<GolfEventField>> {
    let endpoint = `${this.baseUrl}/field`;
    let args:any = { golfEventId: eventId };
    if(hasPaid !== null) {
      args.hasPaid = hasPaid;
    }
    let result = await firstValueFrom(this.http.post<GolfEventField[]>(endpoint, args));
    return result;
  }

  async updateFieldHasPaid(fieldId:number, hasPaid:boolean):Promise<void> {
    let endpoint = `${this.baseUrl}/haspaid`;
    await firstValueFrom(this.http.patch(endpoint, { fieldId: fieldId, hasPaid: hasPaid }));
  }

  generatePaymentLink(event:GolfEvent):string {
    let link = this.configService.getPaymentServiceLink();
    let username = this.configService.getPaymentServiceUsername();

    link = link.replace('{username}', username);
    const note = encodeURIComponent(event.eventName);//.replace(/\+/g, '%20'); //Trying to get the symbols out of the note in Venmo but it's breaking on iPhone for some reason.
    link = link.replace('{tag}', note);
    link += "&amount=" + event.entryFee;
    return link;
  }

  async getLeagueRounds(leagueWeekId:number):Promise<Array<LeagueRound>> {
    let rounds:Array<LeagueRound> = [];

    if(leagueWeekId === 7)
      rounds = this.getWeek7Rounds();
    
    return rounds;
  }

  async postScores(scores:Array<PostScoreRequest>):Promise<boolean> {
    let email = '';
    if(this.authenticationService.loginResult && this.authenticationService.loginResult.player)
      email = this.authenticationService.loginResult.player.email;

    let scoresWithEmail:Array<PostScoreRequest> = [];
    scores.forEach(s => {
      s.email = email;
      scoresWithEmail.push(s);
    });

    let endpoint = `${this.baseUrl}/leagueround`;
    let result = await firstValueFrom(this.http.post<boolean>(endpoint, scoresWithEmail));
    return result;
  }

  private getWeek7Rounds():Array<LeagueRound>{
    return [
      { id: 1, leagueWeekId: 7, playerFirstName: "Jason", playerLastName: "Krumbholz", playerId: 2, score: 31, isDeleted: false },
      { id: 2, leagueWeekId: 7, playerFirstName: "Jason", playerLastName: "Krumbholz", playerId: 2, score: 28, isDeleted: false },
      { id: 3, leagueWeekId: 7, playerFirstName: "Jason", playerLastName: "Krumbholz", playerId: 2, score: 31, isDeleted: false },
      { id: 4, leagueWeekId: 7, playerFirstName: "John", playerLastName: "Strawn", playerId: 1, score: 31, isDeleted: false },
      { id: 5, leagueWeekId: 7, playerFirstName: "John", playerLastName: "Strawn", playerId: 1, score: 30, isDeleted: false },
      { id: 6, leagueWeekId: 7, playerFirstName: "Jason", playerLastName: "Krumbholz", playerId: 2, score: 34, isDeleted: false },
    ];
  }
}